<template>
  <div class="media" @click="details(options)">
    <div class="media-box">
      <div class="content">
        <div v-if="options.photo.length<1">
          <p class="span-bold">{{ options.title || options.keyword }}</p>
          <p>
            <span v-if="options.is_top==1" class="span-red">置顶</span>
            <span class="span-default">{{ options.user_name }}</span>
            <span class="span-default">{{ options.time }}</span>
          </p>
        </div>
        <div v-else-if="options.photo.length<3">
          <el-row>
            <el-col :span="5">
              <el-image :src="options.photo[0]" style="height: 110px;width: 100%" fit="cover"/>
              <i class="iconfont icon-bofang" v-if="options.type==2"></i>
            </el-col>
            <el-col :span="19" style="padding-left: 10px;">
              <p class="p-bold">{{ options.title || options.keyword }}</p>
              <p>
                <span v-if="options.is_top==1" class="span-red">置顶</span>
                <span class="span-default">{{ options.user_name }}</span>
                <span class="span-default">{{ options.time }}</span>
              </p>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <p class="span-bold">{{ options.title || options.keyword }}</p>
          <el-row>
            <template v-for="(photo,index) of options.photo" v-if="index<3">
              <el-col :span="5" class="imgs">
                <el-image :src="photo" style="height: 110px;width: 100%" fit="cover"/>
              </el-col>
            </template>
          </el-row>
          <p>
            <span v-if="options.is_top==1" class="span-red">置顶</span>
            <span class="span-default">{{ options.user_name }}</span>
            <span class="span-default">{{ options.time }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WorkspaceJsonMediaitem',
  data() {
    return {
      moreShow: false,
      hasMore: false,//是否有更多文本
      textHeight: 0,//文本高度
    };
  },
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    uid: {
      type: Number,
      default() {
        return 0
      }
    },
  },
  mounted() {
    if (this.options.content){
      this.textlength = this.delHtmlTag(this.options.content).length;
    }
    if (this.textlength > 100)
      this.hasMore = true;
  },
  methods: {
    remove() {
      this.moreShow = false;
      this.$emit('delItem', this.options)
    },
    /*去掉所有的html标记*/
    delHtmlTag(str) {
      if (str) return str.replace(/<[^>]+>/g, "");//去掉所有的html标记
    },
    /*查看详情*/
    details(row){
      /*文章类型（1：文章， 2：视频 ,3:横版大图（广告模式下使用）,4:小图（广告模式下使用））*/
      if (row.type == 2) {
        let routeData = this.$router.resolve({
          name: "videoDetails",
          query:{
            id:row.id,
            type:row.type,
          },
          params:{cid:this.cid},
          path: '/article/videoDetails',
        });
        window.open(routeData.href, '_blank')
      } else {
        if (row.cid == 0) {
          let routeData = this.$router.resolve({
            name: "articleDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/articleDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "dynamic") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "policy") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "notice") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        }
      }
    },
  }
}
</script>
<style scoped>
.media >>> .Statistics .el-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;
  padding: 0px 0;
}

.vxe-table--render-default .vxe-body--column:not(.col--ellipsis), .vxe-table--render-default .vxe-footer--column:not(.col--ellipsis), .vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 5px 0;
  border-bottom: 1px solid #DDE3E8;
}

.media >>> .el-drawer__wrapper .el-drawer__container .el-drawer .el-drawer__header .el-drawer__close-btn {
  z-index: 999;
  position: absolute;
  right: 10px;
}

.media >>> .el-drawer__header {
  margin-bottom: 0px !important;
  padding: 10px 20px 10px !important;
  border-bottom: 1px solid #E4ECF5;
}

.content .total .el-checkbox .el-checkbox__input .el-checkbox__inner {
  width: 14pt;
  height: 14pt;
}

.content .total .el-checkbox .el-checkbox__label {
  font-size: 14pt;
}

.el-drawer__body ::-webkit-scrollbar {
  width: 8px;
}

.el-drawer__body ::-webkit-scrollbar-thumb {
  background-color: #DDDDDD;
}

.vxe-body--column .item-Volume2 {
  float: left;
  margin-top: 5px;
  margin-right: 15px;
}

.vxe-body--column .item-Volume2 .item-span {
  float: left;
}

.vxe-body--column .item-Volume2 .item-display {
  float: left;
}

.vxe-icon--caret-top, .vxe-icon--caret-bottom {
  color: #8FA2B8;
}

.vxe-icon--caret-top:hover, .vxe-icon--caret-bottom:hover {
  color: #0067DD;
}
</style>
<style scoped lang="scss">
.media {
  padding: 10px 0px;
  border-bottom: 1px dashed #dddddd;
  margin: 15px 0px;
  .span-bold {
    font-size: 20px;
    font-family: 'SourceHanSansCN';
    color: #333;
    margin-block-start: 0em;
    margin-block-end: 0em;
  }
  .p-bold{
    font-size: 18px;
    font-weight: 100;
    font-family: 'SourceHanSansCN';
    color: #333;
    margin-block-start: 0em;
    margin-block-end: 0em;
    min-height: 80px;
  }
  .imgs{
    margin-right: 10px;
    margin-top: 10px;
  }
  p {
    font-size: 16px;
    margin-block-start: 10px;
    margin-block-end: 10px;

    .span-red {
      color: #FE273B;
      font-size: 14px;
      padding-right: 20px;
      font-weight: 100;
      ;
    }

    .span-default {
      padding-right: 20px;
      color: #999999;
      font-size: 14px;
      font-weight: 100;
      font-family: 'SourceHanSansCN';
    }
  }
  .icon-bofang{
    font-size: 30px;
    color: white;
    margin-top: 4.5%;
    position: absolute;
    margin-left: -12.2%;
  }
}
</style>
<style>
.el-drawer__header {
  margin-bottom: 10px;
  padding: 0px 20px 0;
}

.vxe-modal--wrapper .vxe-modal--content {
  padding: 15px 20px 30px;
}

.button-sort {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #FFF;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}

.el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0px;
}

.el-radio {
  color: #606266;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  outline: 0;
  margin-right: 5px;
  min-width: 190px;
  margin-bottom: 10px;
}
</style>